import React from 'react';
import PropTypes from 'prop-types';
import { LayoutContainer } from './containers';
import { DEFAULT_DASHBOARD_VIEW, DEFAULT_SESSION_KEY } from '../../constants/constants';
import HeaderNav from '../../new-ui/layout/Header/HeaderNav';
import { BrowserRouter } from 'react-router-dom';
import CollapsibleMenuContainer from 'src/new-ui/library/CollapsibleLeftPanel/CollapsibleMenuContainer';
import { fnShowNewDashboard, fnOnNavOpen } from 'src/helpers/commonFunctions';
import CaseDataEmployeeHeader from 'src/new-ui/features/CaseDataEmpHeader/CaseDataEmployeeHeader';
import CaseDataLeftPanel from 'src/new-ui/library/CaseDataLeftPanel/CaseDataLeftPanel';
import { Grid } from '@material-ui/core';

export default function Layout({ children, showUserCompany, isConsentPage }) {
  let isDefaultOldView = false;
  sessionStorage.setItem(DEFAULT_SESSION_KEY, isDefaultOldView ? DEFAULT_DASHBOARD_VIEW.EXISTING : DEFAULT_DASHBOARD_VIEW.NEW);

  return (
    <React.Fragment>
      <LayoutContainer>
        <HeaderNav showUserCompany={showUserCompany} isConsentPage={isConsentPage}></HeaderNav>
        {isConsentPage ? (
          <BrowserRouter>{children}</BrowserRouter>
        ) : fnShowNewDashboard() ? (
          <div className="left-panel">
            <BrowserRouter>
              <CollapsibleMenuContainer />
              <main className="persistant-menu-contents" onClick={() => fnOnNavOpen()}>
                {children}
              </main>
            </BrowserRouter>
          </div>
        ) : (
          <React.Fragment>
            <BrowserRouter>
              <CaseDataEmployeeHeader></CaseDataEmployeeHeader>
              <Grid container>
                <Grid item className="case-data-left-panel">
                  <CaseDataLeftPanel></CaseDataLeftPanel>
                </Grid>
                <Grid item className="case-data-right-panel">
                  {children}
                </Grid>
              </Grid>
            </BrowserRouter>
          </React.Fragment>
        )}
      </LayoutContainer>
    </React.Fragment>
  );
}

Layout.propTypes = {
  /* Name used in H2 header */
  headerName: PropTypes.string.isRequired,
};
